import baseSlice from "./component-library297.mjs";
function castSlice(array, start, end) {
  var length = array.length;
  end = end === void 0 ? length : end;
  return !start && end >= length ? array : baseSlice(array, start, end);
}
export {
  castSlice as default
};
